import { AuthenticatedGateClient, GateServer, GateServerConfig } from "../GateServer.js";

export class DefaultGateServer extends GateServer {
  constructor(config: GateServerConfig) {
    super(config);
  }
  onAuthenticate(opts: any): Promise<any> {
    // console.log('IN ONAUTH', { opts })
    return opts || true;
  }
  onJoinGame(client: AuthenticatedGateClient, opts: string | number | { gameId: string | number }): string | number {
    // console.log('receiving on join game request from client:', client.publicId, client.privateId, 'and opts was:', opts);
    if(!this.games.length) {
      throw new Error(`No games found...`)
    }
    let gameId;
    //console.log('OPTS WAS', opts, typeof opts);
    if(typeof opts === "object" && opts !== null) {
      if(!('gameId' in opts)) {
        throw new Error(`If passing up an object to joinGame you must provide a gameId`)
      }
      gameId = opts.gameId;
    } else if((typeof opts !== "string" && typeof opts !== "number") || (!opts && opts !== 0 && opts !== '0')) {
       throw new Error(`Default gate server expects joinGame options to be a string of the gameId'`);
    } else {
      gameId = opts;
    }
    const game = this.games.find(g => g.id === gameId);
    if(!game) {
      throw new Error(`Game for option: ${opts} did not exist`);
    }
    return game.id; 
  }
}